import { Pin } from 'lucide-react'
import * as React from 'react'

import { PinnedMessage } from '@/types/chat.type'

interface PinnedMessagesHeaderProps {
  pinnedMessages: PinnedMessage[]
  onViewPinnedMessages?: () => void
}

export const PinnedMessagesHeader: React.FC<PinnedMessagesHeaderProps> = ({ pinnedMessages, onViewPinnedMessages }) => {
  if (!pinnedMessages || pinnedMessages.length === 0) {
    return null
  }

  return (
    <div
      className="border-b bg-blue-50/50 px-4 py-2 cursor-pointer hover:bg-blue-100/50 transition-colors"
      onClick={onViewPinnedMessages}
    >
      <div className="flex items-center gap-2">
        <Pin className="w-4 h-4 text-blue-600" />
        <span className="text-xs font-medium text-gray-700">
          {pinnedMessages.length} Pinned Message{pinnedMessages.length > 1 ? 's' : ''}
        </span>
        <span className="text-xs text-gray-500">• Click to view all</span>
      </div>
    </div>
  )
}
